export default __webpack_public_path__ + "static/media/books2-afterB-1024w.14b19d39.avif";